import React from 'react';
import PropTypes from 'prop-types';
import { Popup, Label } from 'semantic-ui-react';
import _ from 'lodash';
import numeral from 'numeral';

const catLabelStyle = {
  textTransform: 'uppercase',
  width: 80,
};

const lowerLimits = {
  mega: 1000000,
  xLarge: 500000,
  large: 100000,
  medium: 50000,
  small: 10000,
};

const cf = num => numeral(num).format('0,0');

const categories = {
  mega: {
    text: 'mega',
    description: `more than ${cf(lowerLimits.mega)} followers`,
  },
  xLarge: {
    text: 'x-large',
    description: `more than ${cf(lowerLimits.xLarge)} followers, less than ${cf(lowerLimits.mega)}.`,
  },
  large: {
    text: 'large',
    description: `more than ${cf(lowerLimits.large)} followers, less than ${cf(lowerLimits.xLarge)}.`,
  },
  medium: {
    text: 'medium',
    description: `more than ${cf(lowerLimits.medium)} followers, less than ${cf(lowerLimits.large)}.`,
  },
  small: {
    text: 'small',
    description: `more than ${cf(lowerLimits.small)} followers, less than ${cf(lowerLimits.medium)}.`,
  },
  micro: {
    text: 'micro',
    description: `less than ${cf(lowerLimits.small)} followers`,
  },
};

const getBand = largestFollowerCount => {
  if (largestFollowerCount >= lowerLimits.mega) return 'mega';
  if (largestFollowerCount >= lowerLimits.xLarge) return 'xLarge';
  if (largestFollowerCount >= lowerLimits.large) return 'large';
  if (largestFollowerCount >= lowerLimits.medium) return 'medium';
  if (largestFollowerCount >= lowerLimits.small) return 'small';
  return 'micro';
};

const getInfluencerCategory = i => {
  const largestFollowerCount = _.max([i.youtubeCount, i.twitterCount, i.facebookCount, i.instagramCount]);
  const band = getBand(largestFollowerCount);
  return categories[band];
};

const InfluencerCategoryComponent = ({ influencer }) => {
  const influencerCategory = getInfluencerCategory(influencer);

  return (
    <Popup
      trigger={<Label fluid basic size="tiny" style={catLabelStyle}>{ influencerCategory.text }</Label>}
      content={influencerCategory.description}
    />
  );
};

InfluencerCategoryComponent.propTypes = {
  influencer: PropTypes.object.isRequired,
};

export default InfluencerCategoryComponent;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-category/index.js
 **/